export default __webpack_public_path__ + "media/2.81c3b.png";